module.exports = __webpack_public_path__ + "a09232b88d9c993b16eb0732669e6029.svg";